/**
 * @fileoverview
 * Used in worksheet purchases and in general product purchases
 */

async function submitBetaCode({
  code
}) {
  const response = await fetch("/checkout/code", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      code,
      redirect: 'math-blast'
    })
  });

  if (response.ok) {
    return response.json();
  }

  throw await response.json();
}

/**
 * returnSuccessUrl can include 'SUB' which will be replaced by Stripe subscription_id 
 */
async function createCheckoutSession({
  isSubscription,
  priceId,
  returnUrl,
  returnSuccessUrl,
  cancelAtPeriodEnd = false,
  agreed = false,
  source
}) {
  const response = await fetch('/checkout/create-session' +
    (returnUrl ? '?' + new URLSearchParams({
      return_url: returnUrl,
      return_success_url: returnSuccessUrl
    }) : ''), {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      priceId: priceId,
      subscription: isSubscription,
      cancelAtPeriodEnd,
      agreed,
      source
    })
  });

  if (response.ok) {
    return response.json();
  }

  throw new Error((await response.json()).error);
};

// Account-restriction handling. When the page renders #restriction-banner
// (see +restriction-banner mixin), the licence-request modal is suppressed
// and any click on a subscribe / request trigger shows a restriction toast.
function isRestricted() {
  return Boolean(document.getElementById('restriction-banner'));
}
function showRestrictionToast() {
  $('#checkout-error-body').text("This account is restricted. Purchases are disabled. Please contact support.");
  $('#checkout-error').toast('show');
}
// Catch the click in capture phase so we run before checkouts.js's directly-
// bound .subscribe handlers and Bootstrap's data-api modal toggle.
document.addEventListener('click', (e) => {
  if (!isRestricted())
    return;
  const target = e.target.closest('a.subscribe, a.login-required, [data-bs-target="#licence-request-form"], a[href^="/products/manage/"]');
  if (!target)
    return;
  e.preventDefault();
  e.stopImmediatePropagation();
  showRestrictionToast();
}, true);
// Safety net: if Bootstrap still tries to show the modal (data-bs-toggle
// stripping race, programmatic .modal('show'), or any other path) suppress
// it with preventDefault on the show event, which Bootstrap honors.
$(() => {
  $('#licence-request-form').on('show.bs.modal', (e) => {
    if (isRestricted()) {
      e.preventDefault();
      showRestrictionToast();
    }
  });
});

window.addEventListener('load', () => {
  /**
   * @type {import('@stripe/stripe-js').Stripe}
   */
  const stripe = Stripe(PUBLISHABLE_KEY);
  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get('source');

  /** @type {JQuery<HTMLFormElement>} */
  const claimForm = $('#claim');
  /** @type {JQuery<HTMLInputElement>} */
  const codeInput = $('#code');
  claimForm.on('shown.bs.modal', () => {
    codeInput.trigger('focus');
  });
  claimForm.on('submit', async e => {
    try {
      e.preventDefault();
      const response = await submitBetaCode({
        code: codeInput.get(0).value
      });

      fbq('track', 'InitiateCheckout', {
        num_items: 1,
        currency: 'USD',
        product_group: '2j2rqtosqs',
        value: 0,
      });

      const redirect = response.redirect;

      if (redirect) {
        try {
          window.location.href = redirect;
          return;
        } catch (err) {
          console.error(err);
        }
      }
      window.location.reload();
    } catch (err) {
      console.error(err);
      if (err.error) {
        codeInput.get(0).setCustomValidity(err.error);
        claimForm.get(0).reportValidity();
      }
    }
  });
  codeInput.on('input', e => {
    e.target.setCustomValidity('');
  });
  async function subscribe(target, agreed = false) {
    try {
      const priceId = target.dataset.price;
      const isSubscription = Boolean(target.dataset.subscription);
      const cancelAtPeriodEnd = target.dataset.cancel === 'true';

      const session = await createCheckoutSession({
        priceId,
        isSubscription,
        returnUrl: target.dataset.return,
        returnSuccessUrl: target.dataset.successReturn,
        cancelAtPeriodEnd,
        agreed,
        source: source ? source + '-link' : undefined
      });
      if (session.error) {
        if (session.error == 'NEED_AGREEMENTS') {
          $('#UA-modal').modal('show');
          $('#UA-modal').data('target', target);
          return;
        } else
          throw new Error(session.error);
      }

      fbq('track', 'InitiateCheckout', {
        num_items: 1,
        currency: target.dataset.currency || 'USD',
        product_group: '2j2rqtosqs',
        value: target.dataset.value
      });
      const redirected = await stripe.redirectToCheckout({
        sessionId: session.sessionId
      });
    } catch (err) {
      console.error(err);
      const message = err instanceof Error ?
        `Error processing request: ${err.message}` :
        `There was an error processing your request. Please try again later or contact us if you have any concerns.`;
      $('#checkout-error-body').text(message);
      $('#checkout-error').toast('show');
    }
  }
  $('a.subscribe').on('click', (e) => {
    e.preventDefault();
    subscribe(e.target);
  });
  $('a.login-required').on('click', (e) => {
    e.preventDefault();
    window.location.href = `/users/login?return_url=/create/purchase${source ? encodeURIComponent(`?source=${source}`) : ''}&msg=login_required`;
  });
  $('#UA-modal').on('submit', (e) => {
    e.preventDefault();
    const dataProcessingAgreement = $('#dpa').is(':checked');
    const softwareLicenseAgreement = $('#sla').is(':checked');
    if (!dataProcessingAgreement || !softwareLicenseAgreement)
      return;
    $('#UA-modal').modal('hide');
    subscribe($('#UA-modal').data('target'), true);
  });
  $('#licence-request-form').on('submit', async e => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData($('#licence-request-form').get(0)));
    try {
      const response = await fetch('/create/request', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        if (response.status == 204)
          // redirect admin to Requests page
          window.location.href = '/site-licence/requests';
        $('#licence-request-form').modal('hide');
        $('#request-success-email').text(data.invoice_contact_email);
        $('#request-success-response').text(data.po ? "an invoice" : "a quote");
        $('#request-success').toast('show');
        return;
      }
      const errors = await response.json();
      for (const [key, value] of Object.entries(errors.errors)) {
        const input = $(`z[name='${key}']`);
        input.get(0).setCustomValidity(value.msg);
        input.one('input', e => e.target.setCustomValidity(''));
      }
      $('#licence-request-form').get(0).reportValidity();
    } catch (err) {
      $('.invalid-feedback').addClass('d-block');
      setTimeout(() => $('.invalid-feedback').removeClass('d-block'), 10000); ``
    }
  });
  function setFieldsBasedOnLicenceType() {
    const isSite = $('#licence-type').val() == 'site';
    ['#domains'].forEach(id => {
      $(`${id}-group`).toggleClass('d-none', !isSite);
      if (id != '#school-url')
        $(id).prop('required', isSite);
    });
  }
  $('#licence-request-form').on('show.bs.modal', e => {
    if (e.relatedTarget) {
      const licenceType = e.relatedTarget.dataset.licenceType;
      $('#licence-request-form-title').text(licenceType == 'site' ? "Site License Request" : "License Request");
      if (licenceType)
        $('#licence-type').val(licenceType);
      else
        $('#licence-type').val('');
      setFieldsBasedOnLicenceType();
    }
  });
  $('#licence-type').on('change', setFieldsBasedOnLicenceType);
  $('#invoice-to-me').on('change', e => {
    $('#invoice-contact-name').val($('#invoice-contact-name').data('default'));
    $('#invoice-contact-email').val($('#invoice-contact-email').data('default'));
  });
  $('#tax-exempt').on('input', e => {
    if (e.currentTarget.checked)
      $('.tax-exempt-info').removeClass('d-none');
    else
      $('.tax-exempt-info').addClass('d-none');
  });
  function addYear(dateString) {
    let date = new Date(dateString);
    if (isNaN(date.getTime())) // ignore invalid date
      return null;
    date.setUTCFullYear(date.getUTCFullYear() + 1);
    return date.toISOString().slice(0, 10);
  }
  $('#start-date').on('change', e => {
    let end_date = addYear($('#start-date').val());
    if (end_date)
      $('#end-date').val(end_date);
  });
  // if request_id specified, open Request subscription dialog
  const request_id = urlParams.get('request_id');
  if (request_id) {
    if (original_request) {
      $('#original-request-id').val(original_request._id);
      $('#school').val(original_request.school_name);
      $('#school-url').val(original_request.school_url);
      $('#users').val(original_request.users);
      $('#domains').val(original_request.domains);
      $('#start-date').val(original_request.end_date.slice(0, 10));
      $('#end-date').val(addYear(original_request.end_date));
      $('#payment-method').val(original_request.payment_method);
      $('#invoice-contact-name').val(original_request.invoice_contact_name);
      $('#invoice-contact-email').val(original_request.invoice_contact_email);
      $('#invoice-contact-address').val(original_request.invoice_contact_address);
      // tax_exempt is 'requested' | 'verified' | 'no' on the original request;
      // anything other than 'no' means they previously claimed tax-exempt status
      if (original_request.tax_exempt && original_request.tax_exempt !== 'no')
        $('#tax-exempt').prop('checked', true).trigger('input');
      if (original_request.site_licence_id) {
        $('#licence-type').val('site');
        setFieldsBasedOnLicenceType();
      } else if (original_request.users > 1)
        $('#licence-type').val('group');
      else
        $('#licence-type').val('individual');
      $('#requester-id-group').removeClass('d-none');
      $('#requester-id').val(original_request.user_id);
      // if (!original_request.site_licence_id && original_request.users > 1)
      //   $('#comments').val("I need a Group license");
    }
    $('#licence-request-form').modal('show');
  } else if (urlParams.get('requester_id') &&
             typeof onBehalfOfUser !== 'undefined' && onBehalfOfUser) {
    // Admin-only "new request on behalf of" — no prior request to prefill,
    // just seed the readonly requester field so the POST attributes the
    // request to the target user.
    $('#requester-id-group').removeClass('d-none');
    $('#requester-id').val(onBehalfOfUser._id);
    $('#licence-request-form').modal('show');
  }
});